import { Tooltip } from '@mui/material';
import StatusBadge from 'components/new/StatusBadge';
import { EditingStatus } from 'further-types/lp/vehicle-signing-document';

const inProgressMessage =
  'There are fields that still need to be applied to the document, for signatories or witnesses.';

const tooltipTitle = {
  [EditingStatus.NotStarted]: inProgressMessage,
  [EditingStatus.RolesHaveUnassignedFields]: inProgressMessage,
  [EditingStatus.ReadyToUse]:
    'This document is ready to be used. The signing locations and document name are still editable.',
  [EditingStatus.InUse]:
    'The document is in use, so the signing locations and name are no longer editable. If you wish to edit these, please unassign the document from the applications where it is in use, however this will not be possible if any documents have already been signed by one or more signatories.',
};

type Props = {
  editingStatus: EditingStatus;
};

const DocumentEditingStatus: React.FC<Props> = ({ editingStatus }) => {
  const color =
    editingStatus === EditingStatus.ReadyToUse
      ? 'success'
      : editingStatus === EditingStatus.RolesHaveUnassignedFields ||
        editingStatus === EditingStatus.NotStarted
      ? 'warning'
      : 'secondary';

  return (
    <Tooltip placement="top" title={tooltipTitle[editingStatus]}>
      <span>
        <StatusBadge color={color} />
      </span>
    </Tooltip>
  );
};

export default DocumentEditingStatus;
